module.exports = __webpack_public_path__ + "img/search.c3666213.png";